export default __webpack_public_path__ + "static/media/person.3d7f60e0.png";